// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"813":"66bab515","885":"1cc735a7","972":"2bfc1044"}[chunkId] + ".js";
};